// extracted by mini-css-extract-plugin
export default {"endAdornment":"endAdornment___mDfua"};